import {connect} from 'react-redux';
import ReviewOptions, {ReviewOptionsProps} from './ReviewOptions';
import Action from '../../redux/Actions';
import {ModalStates} from '../../globals/Constants';
import ModalEventHandlersModel from '../../types/ModalEventHandlers';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import Themeable from '../../types/Themeable';

const mapStateToProps = (state: ReduxState, ownProps: ReviewOptionsContainerProps): Partial<ReviewOptionsProps> => {
   return {
      isOwner: ownProps.isOwner,
      themeName: ownProps.themeName,
      reviewId: ownProps.reviewId,
      hasComments: ownProps.hasComments,
      latestVersionNumber: ownProps.latestVersionNumber,
      isListView: ownProps.isListView
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<ReviewOptionsProps> => {
   return {
      setModalState: (modalState: ModalStates, modalEventHandlers: ModalEventHandlersModel): void => {
         dispatch(Action.setModalState({modalState}, modalEventHandlers));
      },
      setReviewInactive: (id: string, isActive: boolean): void => {
         dispatch(Action.setReviewInactive(id, isActive));
      }
   };
};

interface ReviewOptionsContainerProps extends Themeable {
   reviewId: string;
   isOwner: boolean;
   hasComments: boolean;
   latestVersionNumber: number;
   isListView: boolean;
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewOptions);
